var n = "_container_b0pkk_1",
  t = {
    container: n
  };
export { n as container, t as default };